import React, { useMemo, useState } from "react";
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from "react-i18next";

import {
  Modal,
  Button,
  Image,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import itemsComponents from "../../../../components/items";

import DeveloperToolIcon from '../../../../assets/images/icons/developer-tool-icon.svg';

import projectServices from "../../../../services/project";
import storeActions from "../../../../store/actions";
import global from "../../../../config/global";
import { validateUrl } from "../../../../utils/validate";

const InstallationGuideModal = (props) => {
  const { t } = useTranslation();
  const { ProgrammingLanguage } = itemsComponents;
  const {
    visible = false,
    onClose = () => {},
  } = props;

  const locale = useSelector((state) => state.system.locale);
  const selectedProject = useSelector((state) => state.project.selectedProject);

  const [callingAPI, setCallingAPI] = useState(false);

  const handleUpdateOnboarding = async () => {
    // update onboarding process
    global.store.dispatch(storeActions.updateChangeProcessKey('step_2'));
    if (selectedProject?.project_onboarding || selectedProject?.role === global.constants.PROJECT_MEMBER_ROLE.READ_ONLY) {
      onClose();
      return; 
    }
    setCallingAPI(true);
    await projectServices.update(selectedProject.id, { project_onboarding: true }).then(async () => {
      global.store.dispatch(storeActions.updateIsFetchProjects(true));
      setTimeout(() => {
        onClose()
      }, 500);
    }).catch((error) => {
      onClose();
    })
    setCallingAPI(false);
  }

  const programmingLanguage = useMemo(() => {
    const data = {
      name: selectedProject?.programming_language,
      label: '',
      download: '',
      requirements: '',
      installation: '',
      doc_url: ''
    };
    if (selectedProject?.programming_language === 'python') {
      data.label = 'Python SDK'
      data.download = global.urls.DOWNLOAD_URLS.PYTHON_SDK
      data.requirements = 'Python 3.6+'
      data.doc_url = global.urls.DOC_LINKS[locale].PYTHON_USAGES
      data.installation = <div>
        <ul>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.python.solution_1'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            pip install --upgrade lockersm
          </div>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.python.solution_2'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            python setup.py install
          </div>
        </ul>
      </div>
    } else if (selectedProject?.programming_language === 'csharp') {
      data.label = '.NET SDK'
      data.download = global.urls.DOWNLOAD_URLS.NET_SDK
      data.requirements = '.NET 3.+'
      data.doc_url = global.urls.DOC_LINKS[locale].NET_USAGES
      data.installation = <div>
        <ul>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.net.solution_1'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            dotnet add package lockersm
          </div>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.net.solution_2'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            nuget install lockersm
          </div>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.net.solution_3'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            Install-Package lockersm
          </div>
        </ul>
      </div>
    } else if (selectedProject?.programming_language === 'java') { 
      data.label = 'Java SDK'
      data.download = global.urls.DOWNLOAD_URLS.JAVA_SDK
      data.requirements = 'Java 18+'
      data.doc_url = global.urls.DOC_LINKS[locale].JAVA_USAGES
      data.installation = <div>
        <ul>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.java.solution_1'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            implementation 'io.locker:lockersm:[version]'
          </div>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.java.solution_2'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            <p>{'<dependency>'}</p>
            <p className="ml-4">{'<groupId>io.locker</groupId>'}</p>
            <p className="ml-4">{'<artifactId>lockersm</artifactId>'}</p>
            <p className="ml-4">{'<version>[version]</version> '}</p>
            <p>{'</dependency>'}</p>
          </div>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.java.solution_3'}
              components={{ b: <b className="font-semibold"/> }}
            />
            <ul className="ml-3">
              <li>
                <span className="flex flex-wrap">
                  <span className="font-semibold">The LockerSM JAR:</span>
                  <span className="ml-1">
                    <a href={global.urls.DOWNLOAD_URLS.JAR}>{global.urls.DOWNLOAD_URLS.JAR}</a>
                  </span>
                </span>
              </li>
              <li>
                <span className="flex flex-wrap">
                  <span className="font-semibold">Google Gson:</span>
                  <span className="ml-1">
                    <a href={global.urls.DOWNLOAD_URLS.GSON}>{global.urls.DOWNLOAD_URLS.GSON}</a>
                  </span>
                </span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    } else if (selectedProject?.programming_language === 'javascript') {
      data.label = 'NodeJS SDK'
      data.download = global.urls.DOWNLOAD_URLS.NODE_SDK
      data.requirements = 'Node 12+'
      data.doc_url = global.urls.DOC_LINKS[locale].NODE_USAGES
      data.installation = <div>
        <ul>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.node.solution_1'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            npm install -S lockersm
          </div>
          <li>
            <Trans
              i18nKey={'onboarding.project_modal.node.solution_2'}
              components={{ b: <b className="font-semibold"/> }}
            />
          </li>
          <div
            className="my-2 px-4 py-2 border border-solid border-black-300 rounded code-box"
          >
            yarn add lockersm
          </div>
        </ul>
      </div>
    } else {
      data.name = 'terminal'
      data.label = 'CLI'
      data.doc_url = global.urls.DOC_LINKS[locale].CLI_USAGES
    }
    return data
  }, [selectedProject, locale])

  return (
    <Modal
      title={
        <div>
          <Image
            src={DeveloperToolIcon}
            preview={false}
          />
          <p className="font-semibold text-2xl mt-2">{t('onboarding.project_modal.title')}</p>
        </div>
      }
      open={visible}
      style={{ top: 100 }}
      width={564}
      onCancel={() => {}}
      closable={false}
      footer={<div className="flex items-center justify-end">
        <Button
          type="primary"
          loading={callingAPI}
          onClick={() => handleUpdateOnboarding()}
        >
          {t('onboarding.project_modal.btn')}
        </Button>
      </div>}
    >
      <div>
        <p>
          {t('onboarding.project_modal.description_1')}
        </p>
        <p>
          {t('onboarding.project_modal.description_2')}
        </p>
      </div>
      <div className="mt-4">
        <ProgrammingLanguage
          name={programmingLanguage?.name}
          width={48}
          height={48}
          className="font-semibold text-xl ml-4"
          label={programmingLanguage?.label}
        />
        <div className="mt-6 max-h-[280px] overflow-auto">
          {
            programmingLanguage?.requirements && <div className="mb-6">
              <p className="font-semibold">{t('onboarding.project_modal.installation_requirements')}</p>
              <div className="ml-3 mt-2 text-black-500">
                {programmingLanguage?.requirements}
              </div>
            </div>
          }
          {
            programmingLanguage?.installation && <div className="mb-6">
              <p className="font-semibold">{t('onboarding.project_modal.installation')}</p>
              <div className="ml-[26px]">
                {programmingLanguage.installation}
              </div>
            </div>
          }
          {
            programmingLanguage?.download && <div className="mb-4">
              <p className="font-semibold">{t('onboarding.project_modal.references')}</p>
              <div className="ml-[26px] text-black-500">
                {(() => {
                  const downloadUrl = validateUrl(programmingLanguage?.download, false);
                  return (
                    <Trans
                      i18nKey={'onboarding.project_modal.see_more_at'}
                      values={{ url: programmingLanguage?.download }}
                      components={{
                        a: <a
                          href={downloadUrl || undefined}
                          target={downloadUrl ? "_blank" : undefined}
                          rel={downloadUrl ? "noopener noreferrer" : undefined}
                          onClick={(e) => {
                            if (!downloadUrl) e.preventDefault();
                          }}
                          className="underline"
                        />
                      }}
                    />
                  );
                })()}
              </div>
            </div>
          }
          {
            programmingLanguage?.label === 'CLI' && <div className="mb-4">
              <p className="font-semibold mb-3">{t('onboarding.project_modal.download_cli')}</p>
              <ul className="ml-[26px]">
                <li className="mb-2">
                  <span className="font-semibold">Windows:</span>
                  <span className="ml-1">
                    <a href={global.urls.DOWNLOAD_URLS.CLI_WINDOWS}>{global.urls.DOWNLOAD_URLS.CLI_WINDOWS}</a>
                  </span>
                </li>
                <li className="mb-2">
                  <span className="font-semibold">Linux:</span>
                  <span className="ml-1">
                    <a href={global.urls.DOWNLOAD_URLS.CLI_LINUX}>{global.urls.DOWNLOAD_URLS.CLI_LINUX}</a>
                  </span>
                </li>
                <li className="mb-2">
                  <span className="font-semibold">Mac ARM64:</span>
                  <span className="ml-1">
                    <a href={global.urls.DOWNLOAD_URLS.CLI_MAC_ARM64}>{global.urls.DOWNLOAD_URLS.CLI_MAC_ARM64}</a>
                  </span>
                </li>
                <li>
                  <span className="font-semibold">Mac x64:</span>
                  <span className="ml-1">
                    <a href={global.urls.DOWNLOAD_URLS.CLI_MAC_X64}>{global.urls.DOWNLOAD_URLS.CLI_MAC_X64}</a>
                  </span>
                </li>
              </ul>
            </div>
          }
        </div>
      </div>
    </Modal>
  );
}

export default InstallationGuideModal;